<ion-header>
  <ion-toolbar color="gallaghergreen">
  <ion-buttons slot="start">
  <ion-button fill="clear" class="link-button" (click)="goBack()" style="color:white;margin-right:10px">
    <ion-icon name="arrow-back-outline" class="back-icon"></ion-icon>
  </ion-button>
</ion-buttons>
    <img
      class="gallagher-logo"
      src="./assets/images/Gallagher Logo -White Transparent.png"
    />
  </ion-toolbar>
</ion-header>
 <div class="loading-container-login"  *ngIf="!loaded">
          <ion-spinner></ion-spinner>
      </div>
<ion-content class="details-page">
 <div  *ngIf="garment?.garmentCode">
    <div class="card"  *ngIf="isSavedSuccessfully">
      <div class="success-container">
          <ion-icon name="checkmark-circle-outline"
              style="font-size:60px; color:#2ecc71;">
          </ion-icon>
          <h2>The repair request has been submitted.</h2>

          <ion-button  size="small"
                        color="gallaghergreen"
                        (click)="goBack()">
              Add New Repair
          </ion-button>
          <ion-button style="margin-left:10px"
              size="small"
              color="gallaghergreen"
              href="https://www.gallagheruniform.com/g-trak-rfid-technology/g-trak-mobile/"
              target="_blank"
              rel="noopener">
              Done
          </ion-button>
      </div>
  </div>
  <div class="card" >
   
  <h4 class="section-title">PRODUCT DETAILS</h4>
    <div class="product-grid">
      <div class="product-info">
         <div class="info-row">
            <ion-icon name="shirt-outline" class="green-icon"></ion-icon>
                <div>
                  <label>Garment ID</label>
                  <span>{{garment.garmentCode}}</span>
                </div>
              </div>

        <div class="info-row">
          <ion-icon name="person-outline"></ion-icon>
          <div>
            <label>User Name</label>
            <span>{{garment.firstName}}  {{garment.lastName}} </span>
          </div>
        </div>
          
        <div class="info-row">  
         <ion-icon name="lock-closed-outline"></ion-icon>
          <div *ngIf="garment?.stopCode; else lockerOnly">
           <label>Stop Code - Locker</label>
          <span>{{ garment.stopCode }} - {{ garment.lockerNum }}</span>
        </div>

        <ng-template #lockerOnly>
          <div>
            <label>Locker</label>
            <span>{{ garment?.lockerNum }}</span>
          </div>
        </ng-template>
        </div>
        <div class="info-row"  *ngIf="garment?.stopCode">
         <ion-icon name="location-outline"></ion-icon>
          <div>
            <label>Stop Name</label>
            <span>{{garment.stopName}} </span>
          </div>
        </div>
        <div class="info-row" *ngIf="!isSavedSuccessfully">
          <ion-icon name="pricetag-outline"></ion-icon>
          <div>
            <label>Product Code</label>
            <span>{{garment.productCode}}</span>
          </div>
        </div> 

        <div class="info-row">
          <ion-icon name="document-text-outline"></ion-icon>
          <div>
            <label>Description</label>
            <span>{{garment.productName}}</span>
          </div>
        </div>
   <div class="selected-reasons-summary" *ngIf="selectedReasons.length > 0 && isSavedSuccessfully">
        <h4 class="section-title">Selected Repair Reasons</h4>

        <ion-list>
          <ion-item *ngFor="let reason of selectedReasons">
            <ion-icon name="checkmark-outline" slot="start" color="success"></ion-icon>
            {{ reason }}
          </ion-item>
        </ion-list>
      </div>
      </div>
    </div>
   
  </div>
<div class="card" *ngIf="!isCorrect">
  <div class="confirm-section" >
      <h4 class="section-title"> Is This Correct Garment ID #{{garmentCode}}</h4>

      <div class="btn-group">
        <ion-button
          size="small"
          color="gallaghergreen"
          (click)="showRepairList()">
          Yes
        </ion-button>
        <ion-button
          size="small"
          color="medium"
          (click)="navigateOnScanPage()"
          style="margin-left:20px">
          No
        </ion-button>
      </div>
    </div>
  </div> 
 <div class="card" *ngIf="!isSavedSuccessfully && isCorrect">
  <h4 class="section-title">REPAIR REASONS</h4>
  <ion-row class="garment-row">
            <ion-col class="ion-no-padding">
                <ion-row>
                    <ion-col>
                      <ion-select placeholder="Select Reason" interface="popover"
                          [interfaceOptions]="{'cssClass': 'wider-popover'}" [(ngModel)]="messageCode" (ionChange)="onReasonChange()"  [value]="null">
                          <ion-select-option value="06">Relable Garment ID</ion-select-option>
                          <ion-select-option value="15">Repair - Belt Loop / Drawstring</ion-select-option>
                          <ion-select-option value="11">Repair - Buttons, Button Holes, Snaps</ion-select-option>
                          <ion-select-option value="13">Repair - Check All</ion-select-option>
                          <ion-select-option value="MSG0010064">Repair - Check Seat / Inner Thigh</ion-select-option>
                          <ion-select-option value="MSG0010031">Repair - Check Zipper</ion-select-option>
                          <ion-select-option value="21">Repair - Emblems</ion-select-option>
                          <ion-select-option value="14">Repair - Pockets</ion-select-option>
                          <ion-select-option value="12">Repair - Seams or Hems</ion-select-option>
                          <ion-select-option value="MSG0010070">Repair - Sleeve/Cuff</ion-select-option>
                          <ion-select-option value="MSG0010042">Repair - Tear</ion-select-option>
                          <ion-select-option value="MSG0010080">Replace - Inspect for Replacement</ion-select-option>
                          <ion-select-option value="05">Send to Customer Service</ion-select-option>
                          <ion-select-option value="MSG0010033">Verify - All Emblems</ion-select-option>
                          <ion-select-option value="MSG0010046">Verify - Name Emblem Spelling</ion-select-option>
                      </ion-select>
                    </ion-col>
                  <ion-col>
                  
                 </ion-col>
                </ion-row>
                <ion-row style="margin-top:10px;margin-bottom:5px">
                    <h4 class="section-title">SELECTED REASONS</h4>
                  </ion-row>
                  
                  <ion-row *ngIf="selectedReasons.length > 0" style="width:100%">
                    <ion-col>

                      <ion-list style="background-color: #f0f0f0; padding: 10px; border-radius: 10px;">
                        <ion-item *ngFor="let reason of selectedReasons; let i = index">
                          {{ reason }}
                          <ion-button  slot="end" fill="clear" color="danger" (click)="removeReason(i)" style="width:50px;">
                            <ion-icon slot="icon-only" name="trash"></ion-icon>
                          </ion-button>
                        </ion-item>
                      </ion-list>
                    </ion-col>
                  </ion-row>
                  <ion-row *ngIf="selectedReasons.length === 0" style="width:100%; height: 100px; background-color: #f0f0f0; display: flex; justify-content: center; align-items: center; border-radius: 10px;">
                    <ion-col>
                      <div style="text-align: center; font-size: 16px; color: #888;">
                        No item Selected
                      </div>
                    </ion-col>
                  </ion-row>
                  
            </ion-col>
        </ion-row>
    </div>
  </div>
<div class="card"  [hidden]="!garment?.garmentCode || isSavedSuccessfully || !isCorrect">
  <div class="captcha-wrapper">
    <div id="captcha-container"></div>
    </div>
 </div>
</ion-content>

<ion-content class="details-page" *ngIf="loaded && !garment?.garmentCode">
 <div class="error-text">
  <ion-icon name="alert-circle-outline"></ion-icon>
  <p>{{ garment }}</p>
    <ion-button  size="small"
                  color="gallaghergreen"
                  (click)="goBack()">
        Try Again
      </ion-button>
  </div>
    
</ion-content>
 
<ion-footer *ngIf="garment?.garmentCode && !isSavedSuccessfully && isCorrect">
  <ion-button expand="block" class="save-btn" color="gallaghergreen" (click)="PostMessage()">
    SAVE REPAIRS
  </ion-button>
</ion-footer>